<template>
  <div class="update">
    <mu-dialog title="编辑菜单" width="500" :open="open" @close="close">
      <mu-form :model="editForm" label-position="left" label-width="100">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="editForm.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="description" label="描述">
          <mu-text-field v-model="editForm.description"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="url" label="页面url">
          <mu-text-field v-model="editForm.url"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="apiUrl" label="apiUrl">
          <mu-text-field v-model="editForm.apiUrl"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="icon" label="icon">
          <mu-text-field v-model="editForm.icon"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="menuLevel" label="菜单等级">
          <mu-radio
            value="一级"
            v-model="editForm.menuLevel"
            label="一级"
          ></mu-radio>
          <mu-radio
            value="二级"
            v-model="editForm.menuLevel"
            label="二级"
          ></mu-radio>
          <mu-radio
            value="三级"
            v-model="editForm.menuLevel"
            label="三级"
          ></mu-radio>
        </mu-form-item>

        <mu-form-item prop="parent" label="父菜单">
          <mu-select v-model="editForm.parent.id">
            <mu-option
              v-for="(item, index) in parentMenuList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="isMenu" label="是否为菜单">
          <mu-radio
            :value="true"
            v-model="editForm.isMenu"
            label="是"
          ></mu-radio>
          <mu-radio
            :value="false"
            v-model="editForm.isMenu"
            label="否"
          ></mu-radio>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {
        parent: {
          id: 1
        }
      },
      allMenuList: [],
      parentMenuList: []
    }
  },
  methods: {
    submit() {
      backend(api.menu.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllMenus() {
      backend(api.menu.getAll, { getAll: true }).then((result) => {
        if (result.statusCode === 200) {
          this.allMenuList = result.data.rows
        }
      })
    }
  },
  mounted() {
    this.getAllMenus()
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    },
    'editForm.menuLevel': {
      handler(val) {
        if (val === '一级') {
          this.parentMenuList = this.allMenuList.filter(
            (x) => x.menuLevel === '根菜单'
          )
        } else if (val === '二级') {
          this.parentMenuList = this.allMenuList.filter(
            (x) => x.menuLevel === '一级'
          )
        } else if (val === '三级') {
          this.parentMenuList = this.allMenuList.filter(
            (x) => x.menuLevel === '二级'
          )
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.update {
}
</style>



// WEBPACK FOOTER //
// src/views/menu/update.vue